import React from "react";
import { cartColor } from "Icons/index";
import Navbar from "Components/navbar/Navbar";
import PropTypes from "prop-types";
import _ from "lodash";
import getCustomerLinks from "./CustomerLink";
import getAdminLinks from "./AdminLink";
import getManagerLinks from "./ManagerLink";
import getTeamMemberLinks from "./TeamMemberLink";
import getEmailAccountLinks from "./EmailAccountLink";
import getPostmasterLinks from "./PostmasterLink";
import SidebarItem from "Components/sidebar/SidebarItem";
import Modal from "Components/smallModal/smallModal";
import Button from "Components/button/Button";
import PoweredBy from "Components/poweredBy/PoweredBy";
import TranslatedString from "Components/TranslatedString";
import { t } from "i18next";
import cx from "classnames";
import s from "./sidebar.scss";
import sessionStore from "@/stores/session";
import QboxmailApi from "@/qboxmailApi";

const api = new QboxmailApi({ useCookie: true });

const ContextType = {
  getLoggedUserType: PropTypes.func,
  isLoggedUserAdmin: PropTypes.func,
  getLoggedUser: PropTypes.func,
  isLoggedUserExpired: PropTypes.func,
  isMobileDevice: PropTypes.func,
  isMediaMobile: PropTypes.func,
  isMediaSM: PropTypes.func,
  isMediaMD: PropTypes.func,
  isMediaLG: PropTypes.func,
};

class Sidebar extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      showTrialModal: false,
      pricesIcon: null,
    };
  }

  componentDidMount() {
    let loggedUser = this.context.getLoggedUser();

    this.setState({
      showTrialModal: this.openTrialModal(loggedUser.plan),
    });

    if (loggedUser.type === "Customer" && loggedUser.is_reseller && loggedUser.plan === "paid") {
      this.checkPriceTier();
    }

    if (loggedUser.type === "Customer") {
      sessionStore.checkPendingMTMRequests();
    }
  }

  async checkPriceTier() {
    const tier = await api.getCustomerTierPrices().catch((err) => {
      console.log(err);
      return null;
    });

    if (!tier) return;

    this.setState({ pricesIcon: tier.icon });
  }

  toggleClass(element, className) {
    let classes = element.className.split(/\s+/);
    let length = classes.length;
    let i = 0;

    for (; i < length; i++) {
      if (classes[i] === className) {
        classes.splice(i, 1);
        break;
      }
    }
    document.getRootNode().children[0].style.overflowY = "auto";
    document.getRootNode().children[0].style.overflowX = "auto";
    // The className is not found
    // activate the sidebar
    if (length === classes.length) {
      classes.push(className);
      document.getRootNode().children[0].style.overflowY = "hidden";
      document.getRootNode().children[0].style.overflowX = "hidden";
    }

    element.className = classes.join(" ");
  }

  //eslint-disable-next-line
  toggleAll(e) {
    let active = "active";

    // if (e) e.preventDefault()
    this.toggleClass(this.state.layout, active);
    this.toggleClass(this.state.menu, active);
    // this.toggleClass(this.state.menuLink, active);
  }

  isDelivery = () => {
    const { pathname } = this.props.location;
    return pathname.split("/").includes("delivery");
  };

  isSettings = () => {
    const { pathname } = this.props.location;
    return pathname.split("/")[1] === "account";
  };

  checkIfActive = (routeName) => {
    const {
      location: { pathname },
    } = this.props;

    let urlNormalized = pathname[0] === "/" ? pathname : "/" + pathname;

    const postmasterOpened = urlNormalized.match(/P\d{9}\/settings/);

    let parts = urlNormalized.split("/");
    if (routeName === "customers") {
      return parts[1] === "customers" && parts.length <= 2;
    } else if (routeName === "postmasters") {
      return postmasterOpened || parts[1].includes(routeName);
    } else if (routeName === "domains" && this.context.isLoggedUserAdmin() && !postmasterOpened) {
      return parts[1] === "domains" || parts[3] === "domains";
    } else if (routeName === "migrations/options") {
      return urlNormalized.indexOf(routeName) >= 0;
    } else if (routeName === "migrations") {
      return urlNormalized.indexOf("/migrations/status") != 0 && urlNormalized.indexOf("/migrations") === 0;
    }

    if (this.isDelivery()) {
      if (routeName === "delivery") {
        return parts.length <= 2;
      } else if (routeName === "delivery/accounts") {
        return urlNormalized.includes("delivery/accounts");
      } else if (routeName === "delivery/domains") {
        return urlNormalized.includes("delivery/domains");
      } else if (routeName === "delivery/suppression-list") {
        return urlNormalized.includes("delivery/suppression-list");
      }
    }

    if (parts[1] === routeName) {
      return true;
    }

    return "/" + routeName === urlNormalized;
  };

  //eslint-disable-next-line
  toggle = (e) => {
    if (this.context.isMediaMobile() || this.context.isMediaSM()) {
      this.props.setShowSidebar(false);
    } else if (this.context.isMediaMD()) {
      this.props.setCompactSidebar(true);
    }
  };

  toggleSidebar = () => {
    if (this.context.isMediaMobile() || this.context.isMediaSM()) {
      this.props.setShowSidebar(!this.props.showSidebar);
    }
  };

  toggleCompactSidebar = () => {
    if (this.context.isMediaMD() || this.context.isMediaLG()) {
      this.props.setCompactSidebar(!this.props.compactSidebar);
    }

    if (this.props.compactSidebar) {
      document.body.style.setProperty("--current-sidebar-width", "230px");
    } else {
      document.body.style.setProperty("--current-sidebar-width", "38px");
    }

    if (this.context.isMediaLG()) {
      window.localStorage.setItem("qb_sidebar_compact_status", JSON.stringify(!this.props.compactSidebar));
    }
  };

  renderExpired() {
    return [
      {
        category: "",
        links: [
          {
            path: "/orders",
            label: "sidebar.item.orders",
            icon: cartColor,
          },
        ],
      },
    ];
  }

  goToHome = () => {
    this.props.history.push("/home");
  };

  openTrialModal = (plan) => {
    if (plan === "trial") {
      if (!sessionStorage.getItem("qb_showTrialModal")) {
        sessionStorage.setItem("qb_showTrialModal", true);
        return true;
      }
    } else {
      sessionStorage.removeItem("qb_showTrialModal");
    }
    return false;
  };

  closeTrialModal = () => {
    this.setState({
      showTrialModal: false,
    });
  };

  canAccessDelivery = (loggedUser) => {
    // sidebar can be seen by:
    // - admin
    // - customer paying
    // - team member with permission "see_delivery"
    // - managers
    let canAccessDelivery = false;

    if (loggedUser.type === "Customer") {
      const isPayingForHosting =
        (loggedUser.plan === "paid" && loggedUser.status_detail !== "wait_pay") || loggedUser.plan === "free";

      canAccessDelivery = isPayingForHosting;
      return canAccessDelivery;
    }

    if (
      loggedUser.type === "TeamMember" &&
      !loggedUser.is_customer_trial &&
      loggedUser.permissions.includes("see_delivery")
    ) {
      canAccessDelivery = true;
      return canAccessDelivery;
    }

    if (loggedUser.type === "Manager") {
      return true;
    }

    return canAccessDelivery;
  };

  render() {
    const { compactSidebar, showSidebar } = this.props;
    const { showTrialModal } = this.state;

    const { getLoggedUserType, getLoggedUser, isLoggedUserAdmin, isLoggedUserExpired, isMediaMobile, isMediaSM } =
      this.context;

    const loggedUser = getLoggedUser();

    let roleEntries;
    const isDelivery = this.isDelivery();

    const hideDeliverySidebar = !isLoggedUserAdmin() && isDelivery && !this.canAccessDelivery(loggedUser);


    this.isSettings();

    if (isLoggedUserAdmin()) {
      roleEntries = getAdminLinks(isDelivery);
    }

    if (getLoggedUserType() === "Customer" && isLoggedUserExpired()) {
      roleEntries = this.renderExpired();
    }

    if (getLoggedUserType() === "Customer" && !isLoggedUserExpired()) {
      roleEntries = getCustomerLinks(loggedUser, this.props.history, isDelivery);
    }

    if (getLoggedUserType() === "Postmaster") {
      roleEntries = getPostmasterLinks(loggedUser);
    }

    if (getLoggedUserType() === "Manager") {
      roleEntries = getManagerLinks(loggedUser, this.props.history, isDelivery);
    }

    if (getLoggedUserType() === "TeamMember") {
      roleEntries = getTeamMemberLinks(loggedUser, this.props.history, isDelivery);
    }

    if (getLoggedUserType() === "EmailAccount") {
      roleEntries = getEmailAccountLinks(loggedUser);
    }

    return (
      <div
        id="layout"
        className={cx(s.appContainer, {
          [s.compactSidebar]: compactSidebar,
        })}
      >
        <Navbar
          className={s.navbar}
          onClickMenu={isMediaMobile() || isMediaSM() ? this.toggleSidebar : this.toggleCompactSidebar}
          hideMenuIcon={hideDeliverySidebar}
          logout={this.props.logout}
          pricesIcon={this.state.pricesIcon}
          onTrialBannerClick={() => this.setState({ showTrialModal: true })}
          isDelivery={this.isDelivery()}
          isSettings={this.isSettings()}
        />

        {showSidebar && !hideDeliverySidebar && (
          <div id="menu" className={s.sidebar}>
            <div className={s.sidebarItems}>
              {roleEntries.map((category) => (
                <div
                  key={_.compact(category.links)
                    .map((link) => link.label)
                    .join()}
                  className={category.stepName}
                >
                  {category.category && (
                    <div
                      className={`w-full h-6 text-xs leading-6 text-qb-text pl-4 mt-2 opacity-70 ${
                        compactSidebar ? "h-3 mb-3 border-0 border-b-2 border-solid border-[--bg-d5]" : ""
                      }`}
                    >
                      {!compactSidebar && t(category.category)}
                    </div>
                  )}
                  {_.compact(
                    category.links.map((entry) => {
                      if (!entry || entry.hide) return undefined;

                      return (
                        <SidebarItem
                          {...entry}
                          history={this.props.history}
                          toggle={this.toggle}
                          key={entry.path + entry.category + entry.label}
                          selected={entry.path ? this.checkIfActive(entry.path.slice(1)) : false}
                          compact={compactSidebar}
                        />
                      );
                    })
                  )}
                </div>
              ))}
            </div>

            {!compactSidebar && <PoweredBy className={s.sidebarFooter} isInSidebar />}
          </div>
        )}

        <div id="app-content" className={s.content}>
          {React.cloneElement(this.props.children, {
            isMediaMobile: this.props.isMediaMobile,
            isMediaSM: this.props.isMediaSM,
            isMediaMD: this.props.isMediaMD,
            isMediaLG: this.props.isMediaLG,
            showSidebar: this.props.showSidebar,
            compactSidebar: this.props.compactSidebar,
          })}
        </div>

        {loggedUser.days_until_expiration <= 25 && (
          <Modal title={t("modal.trial.title")} opened={showTrialModal}>
            <div
              className={cx(s.bodyTrailModal, {
                [s.wranExpire]: loggedUser.days_until_expiration <= 8,
                [s.expire]: loggedUser.days_until_expiration <= 0,
              })}
            >
              <div className={s.wrapDaysTrial}>
                <div className={s.daysTrial}>
                  {loggedUser.days_until_expiration > 0 ? loggedUser.days_until_expiration : "0"}
                </div>
                <div className={s.daysTextTrial}>{t("modal.trial.days.left")}</div>
              </div>

              <div className={s.msgTtrial}>
                <TranslatedString>
                  {loggedUser.days_until_expiration <= 0 ? `modal.trial.desc.endTrial` : `modal.trial.desc`}
                </TranslatedString>
              </div>
            </div>
            <div className={s.footerTrial}>
              {loggedUser.days_until_expiration > 0 && (
                <Button type="button" color="text" onClick={this.closeTrialModal}>
                  button.close
                </Button>
              )}

              {loggedUser.days_until_expiration === 0 && (
                <Button type="button" color="text" onClick={this.props.logout}>
                  button.logout
                </Button>
              )}

              <Button
                type="button"
                color="green"
                onClick={() => {
                  this.setState(
                    {
                      showTrialModal: false,
                    },
                    () => {
                      this.props.history.push("/orders/new#1");
                    }
                  );
                }}
              >
                button.buy
              </Button>
            </div>
          </Modal>
        )}
      </div>
    );
  }
}

Sidebar.contextTypes = ContextType;

export default Sidebar;
